// extracted by mini-css-extract-plugin
module.exports = {"formBody":"GenerateLead_formBody__EUswP"};